var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02451 22H15.0409C20.0546 22 22.0601 20 22.0601 15V9C22.0601 4 20.0546 2 15.0409 2H9.02451C4.01084 2 2.00537 4 2.00537 9V15C2.00537 20 4.01084 22 9.02451 22Z",
    stroke: "#2A2D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.949 9.04973C15.763 8.82973 13.557 8.71973 11.361 8.71973C10.0574 8.71973 8.75389 8.78972 7.46036 8.91972L6.1167 9.04973",
    stroke: "#2A2D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73633 8.38994L9.87671 7.52994C9.97698 6.90994 10.0572 6.43994 11.1702 6.43994H12.8949C14.008 6.43994 14.0882 6.92994 14.1885 7.52994L14.3288 8.37994",
    stroke: "#2A2D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5351 9.12988L16.1039 15.7299C16.0337 16.7599 15.9736 17.5599 14.1386 17.5599H9.91704C8.08204 17.5599 8.02187 16.7599 7.95168 15.7299L7.52051 9.12988",
    stroke: "#2A2D34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f53ca9b13f3845d59cee4d8495337615.svg";
export { ForwardRef as ReactComponent };